<template>
    <v-card rounded="lg">
        <v-card-title>
            <h2 class="icon-title mb-0" style="width:100%; align-items:center;">
                {{ $t("externalCalendars") }}
            </h2>
        </v-card-title>
        <v-card-text>
            <v-alert border="left" text color="info">
                {{ $t('external_calendar_explanation_text') }}
            </v-alert>
            <v-btn v-if="!hasGoogle" @click="authenticateGoogle" elevation="4">
                <v-img contain width="30" class="mr-2" :src="`${publicPath}`+'img/Google_Calendar_icon.png'"></v-img>
                <div style="font-size:14px;">{{$t('connectWithGoogle')}}</div>
            </v-btn>
            <v-btn dense v-else @click="unregisterGoogle" elevation="4">
                <v-img contain width="30" class="mr-2" :src="`${publicPath}`+'img/Google_Calendar_icon.png'"></v-img>
                <div style="font-size:14px;">{{$t('disconnectGoogleAccount')}}</div>
            </v-btn>
            <v-btn v-if="!hasOutlook" @click="authenticateOutlook" color="info" class="ml-2" elevation="4">
                <v-img contain width="30" class="mr-2" :src="`${publicPath}`+'img/Outlook-icon.png'"></v-img>
                <div style="font-size:14px;">{{$t('connectWithOutlook')}}</div>
            </v-btn>
            <v-btn v-else @click="unregisterOutlook" elevation="4" class="ml-2" color="info">
                <v-img contain width="30" class="mr-2" :src="`${publicPath}`+'img/Outlook-icon.png'"></v-img>
                <div style="font-size:14px;">{{$t('disconnectOutlookAccount')}}</div>
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';

export default {
    name: "connexionCardComponent",
    props: ["user"],
    data() {
        return {
            iframeDialog:false,
            publicPath: process.env.BASE_URL,
            calendarToken: null,
            hasGoogle: false,
            hasOutlook: false,
        };
    },
    mounted() {
        if((this.user && this.user.external_calendar_token)) 
            this.calendarToken = this.user.external_calendar_token;
        
        if((this.$route && this.$route.query && this.$route.query.external_calendar_token)){
            this.calendarToken = this.$route.query.external_calendar_token;
            this.$router.replace({ query: {} })
            GenericDataService.getData('/user/'+this.user.id+'/setExternalCalendarToken?token='+this.calendarToken).then((response) => {
                this.$store.dispatch('ADD_SNACK', { message : this.$t('googleAuthentificationSuccessful') }).then((e) => { this.$store.dispatch("REMOVE_SNACK"); });
            });
        }
            
    },
    watch: {
        calendarToken: function (newVal) {
            if(newVal) {
                GenericDataService.getData(this.calendar_url+"external_calendar/getInfos?token="+newVal).then((response) => {
                    this.hasGoogle = response.data.data.google;
                    this.hasOutlook = response.data.data.outlook;
                });
            }
        },
    },
    computed: {
        calendar_url: function () {
            return process.env.VUE_APP_CAL_URL;
        }
    },
    methods: {
        unregisterGoogle() {
            GenericDataService.postData(this.calendar_url+"external_calendar/unregisterGoogle?token="+this.calendarToken).then((response) => {
                this.hasGoogle = false;
                this.$store.dispatch('ADD_SNACK', { message : this.$t('googleDisconnected') }).then((e) => { this.$store.dispatch("REMOVE_SNACK"); });
            });
        },
        authenticateGoogle() {
            window.location.href = this.calendar_url+"ns/user/googleAuthenticate?user_id="+this.user.id+"&user_email="+this.user.email+"&user_redirect="+window.location.href;
        },
        unregisterOutlook() {
            GenericDataService.postData(this.calendar_url+"external_calendar/unregisterOutlook?token="+this.calendarToken).then((response) => {
                this.hasOutlook = false;
                this.$store.dispatch('ADD_SNACK', { message : this.$t('outlookDisconnected') }).then((e) => { this.$store.dispatch("REMOVE_SNACK"); });
            });
        },
        authenticateOutlook() {
            window.location.href = this.calendar_url+"ns/user/outlookAuthenticate?user_id="+this.user.id+"&user_email="+this.user.email+"&user_redirect="+window.location.href;
        },
    },
};
</script>

<style lang="scss">
</style>
